import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import CONST_COMPONENT from '../../const/component'
import CONST_LINGUAL_NAME from '../../const/lingualName'
import ComponentListTemplate from './ComponentListTemplate'

export default class ComponentListComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.COMPONENT_LIST)

    this.data.component = ComponentListTemplate
    this.socket = config ? config.sockets : null
  }

  // eslint-disable-next-line
  builder(node) {
    node.lingualName = CONST_LINGUAL_NAME.COMPONENT_LIST

    const componentListInput = new Rete.Input(CONST_SOCKET.COMPONENT_LIST_INPUT, '', this.socket.componentListInput, false)

    return node
      .addInput(componentListInput)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {}
}